import { IMarketingCenterTemplate } from '@/models/marketingCenter/template';
import {
  TitleCanvasElement,
  BackgroundImageCanvasElement,
  TextCanvasElement,
  VerticalTextWrapper,
  BrandCanvasElement,
  ColoredSVGCanvasElement
} from '@/models/marketingCenter/elements';
import {
  InstagramPostFormat,
  InstagramStoryFormat,
  FacebookPostFormat
} from '@/models/marketingCenter/formats';
import { EMarketingCenterColorSchemes } from '../colorScheme';

const LoyaltyTemplate: IMarketingCenterTemplate = {
  tag: 'Loyalty Program',
  title: 'Loyalty Program Post',
  description:
    'Explain to your followers what’s a loyal member story and why you want to reward them.',
  disabledDescription:
    'To create a Loyalty Rewards Program Post, first you will need to set up your Loyalty Program.',
  button: {
    label: `Launch Loyalty Program`,
    link: '/coin/loyalty'
  },
  placeholders: {
    title: 'We love to reward those who are loyal!',
    text: 'Earn rewards instantly and redeem for what you love!',
    colorScheme: EMarketingCenterColorSchemes.BLUE,
    titleMaxLength: 39,
    textMaxLength: 54
  },
  formats: [
    new InstagramStoryFormat([
      new BackgroundImageCanvasElement({
        image: 'marketingCenter/canvas/loyalty/instagram-story.png'
      }),
      new BrandCanvasElement({
        width: 52,
        height: 52,
        x: 99,
        y: 300,
        radius: 26,
        borderWidth: 2,
        rotateAngleDeg: -15,
        showBusinessName: true,
        businessNameContainerWidth: 234,
        businessNameContainerX: 8
      }),
      new VerticalTextWrapper({
        elements: [TitleCanvasElement, TextCanvasElement],
        gapsBetween: [10],
        fonts: [
          {
            size: 36,
            lineHeight: 34,
            maxWidth: 189,
            align: 'center',
            numberOfLines: 4
          },
          {
            size: 12,
            lineHeight: 16,
            maxWidth: 167,
            align: 'center',
            weight: 'bold',
            numberOfLines: 3
          }
        ],
        positions: [
          {
            x: 30,
            y: 20
          },
          {
            x: 38,
            y: 20
          }
        ]
      }),
      new ColoredSVGCanvasElement({
        image: 'marketingCenter/canvas/loyalty/button.svg',
        x: 69,
        y: 220,
        width: 106,
        height: 16
      })
    ]),
    new InstagramPostFormat([
      new BackgroundImageCanvasElement({
        image: 'marketingCenter/canvas/loyalty/instagram-post.png'
      }),
      new BrandCanvasElement({
        width: 36,
        height: 36,
        x: -45,
        y: 82,
        radius: 18,
        borderWidth: 2,
        rotateAngleDeg: -15,
        showBusinessName: true,
        businessNameContainerWidth: 137,
        businessNameContainerX: 120
      }),
      new TitleCanvasElement({
        font: {
          size: 17,
          weight: 'bold',
          lineHeight: 20,
          maxWidth: 186
        },
        position: {
          x: 20,
          y: 12
        }
      }),
      new TextCanvasElement({
        font: {
          size: 12,
          weight: 'bold',
          lineHeight: 16,
          maxWidth: 95,
          numberOfLines: 5
        },
        position: {
          x: 22,
          y: 124
        }
      }),
      new ColoredSVGCanvasElement({
        image: 'marketingCenter/canvas/loyalty/button.svg',
        x: 26,
        y: 209,
        width: 106,
        height: 16
      })
    ]),
    new FacebookPostFormat([
      new BackgroundImageCanvasElement({
        image: 'marketingCenter/canvas/loyalty/facebook-post.png'
      }),
      new BrandCanvasElement({
        width: 32,
        height: 32,
        x: 168,
        y: 33,
        radius: 16,
        borderWidth: 2,
        rotateAngleDeg: -15,
        showBusinessName: true,
        businessNameContainerWidth: 112,
        businessNameContainerX: 129
      }),
      new VerticalTextWrapper({
        elements: [TitleCanvasElement, TextCanvasElement],
        gapsBetween: [10],
        fonts: [
          {
            size: 16,
            lineHeight: 16,
            maxWidth: 112,
            numberOfLines: 3
          },
          {
            size: 8,
            lineHeight: 10,
            maxWidth: 112,
            weight: 'bold',
            numberOfLines: 2
          }
        ],
        positions: [
          {
            x: 11,
            y: 9
          }
        ]
      }),
      new ColoredSVGCanvasElement({
        image: 'marketingCenter/canvas/loyalty/button.svg',
        x: 16,
        y: 102,
        width: 91,
        height: 14
      })
    ])
  ]
};

export default LoyaltyTemplate;
